module.exports = __webpack_public_path__ + "static/media/500.5267bafa.png";